import React from 'react';
import './DrinkResponsibly.css';

function DrinkResponsibly() {
  return (
    <div className="drink-responsibly">
      <section className="dr-header">
        <h1>Drink Responsibly</h1>
        <p>If you or someone you know is struggling with alcohol dependency, help is available.</p>
      </section>

      <section className="dr-content">
        <div className="content-wrapper">
          
          <div className="emergency-section">
            <h2>🚨 Emergency Resources</h2>
            <div className="emergency-cards">
              <div className="emergency-card">
                <h3>National Suicide Prevention Lifeline</h3>
                <p className="phone-number">
                  <a href="tel:988">988</a>
                </p>
                <p>24/7 crisis support for anyone in suicidal crisis or emotional distress</p>
              </div>
              
              <div className="emergency-card">
                <h3>Crisis Text Line</h3>
                <p className="phone-number">
                  Text HOME to <a href="sms:741741">741741</a>
                </p>
                <p>24/7 crisis support via text message</p>
              </div>
            </div>
          </div>

          <div className="resources-grid">
            <div className="resource-section">
              <h2>📞 National Helplines</h2>
              
              <div className="resource-item">
                <h3>SAMHSA National Helpline</h3>
                <p className="phone-number">
                  <a href="tel:1-800-662-4357">1-800-662-HELP (4357)</a>
                </p>
                <p>Free, confidential, 24/7 treatment referral service for individuals and families facing mental health and/or substance use disorders.</p>
                <p><strong>Website:</strong> <a href="https://www.samhsa.gov/find-help/national-helpline" target="_blank" rel="noopener noreferrer">samhsa.gov/find-help/national-helpline</a></p>
              </div>

              <div className="resource-item">
                <h3>National Council on Alcoholism and Drug Dependence</h3>
                <p className="phone-number">
                  <a href="tel:1-800-622-2255">1-800-NCA-CALL (622-2255)</a>
                </p>
                <p>Information and referral helpline providing 24-hour assistance.</p>
                <p><strong>Website:</strong> <a href="https://www.ncadd.org" target="_blank" rel="noopener noreferrer">ncadd.org</a></p>
              </div>

              <div className="resource-item">
                <h3>Alcoholics Anonymous (AA)</h3>
                <p className="phone-number">
                  <a href="tel:1-212-870-3400">1-212-870-3400</a>
                </p>
                <p>Find local AA meetings and support groups worldwide.</p>
                <p><strong>Website:</strong> <a href="https://www.aa.org" target="_blank" rel="noopener noreferrer">aa.org</a></p>
              </div>
            </div>

            <div className="resource-section">
              <h2>👥 Support Groups & Organizations</h2>
              
              <div className="resource-item">
                <h3>Al-Anon Family Groups</h3>
                <p>Support for families and friends of people with alcohol problems.</p>
                <p className="phone-number">
                  <a href="tel:1-888-425-2666">1-888-4AL-ANON (425-2666)</a>
                </p>
                <p><strong>Website:</strong> <a href="https://al-anon.org" target="_blank" rel="noopener noreferrer">al-anon.org</a></p>
              </div>

              <div className="resource-item">
                <h3>SMART Recovery</h3>
                <p>Self-Management and Recovery Training - science-based addiction recovery support.</p>
                <p><strong>Website:</strong> <a href="https://www.smartrecovery.org" target="_blank" rel="noopener noreferrer">smartrecovery.org</a></p>
              </div>

              <div className="resource-item">
                <h3>LifeRing Secular Recovery</h3>
                <p>Self-help network of individuals seeking to live in recovery from addiction.</p>
                <p><strong>Website:</strong> <a href="https://lifering.org" target="_blank" rel="noopener noreferrer">lifering.org</a></p>
              </div>

              <div className="resource-item">
                <h3>Women for Sobriety</h3>
                <p>Self-help recovery program for women with alcohol or drug addiction problems.</p>
                <p><strong>Website:</strong> <a href="https://womenforsobriety.org" target="_blank" rel="noopener noreferrer">womenforsobriety.org</a></p>
              </div>
            </div>

            <div className="resource-section">
              <h2>🏥 Treatment Resources</h2>
              
              <div className="resource-item">
                <h3>Treatment Locator</h3>
                <p>Find treatment facilities and programs in your area.</p>
                <p><strong>Website:</strong> <a href="https://findtreatment.samhsa.gov" target="_blank" rel="noopener noreferrer">findtreatment.samhsa.gov</a></p>
              </div>

              <div className="resource-item">
                <h3>National Institute on Alcohol Abuse and Alcoholism (NIAAA)</h3>
                <p>Research-based information about alcohol and alcohol-related problems.</p>
                <p><strong>Website:</strong> <a href="https://www.niaaa.nih.gov" target="_blank" rel="noopener noreferrer">niaaa.nih.gov</a></p>
              </div>

              <div className="resource-item">
                <h3>Behavioral Health Treatment Services Locator</h3>
                <p>Find mental health and substance abuse treatment facilities.</p>
                <p><strong>Website:</strong> <a href="https://findtreatment.gov" target="_blank" rel="noopener noreferrer">findtreatment.gov</a></p>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h2>ℹ️ Important Information</h2>
            <div className="info-content">
              <ul>
                <li><strong>You are not alone.</strong> Millions of people struggle with alcohol dependency, and recovery is possible.</li>
                <li><strong>Seeking help is a sign of strength,</strong> not weakness.</li>
                <li><strong>Treatment works.</strong> There are many effective treatment options available.</li>
                <li><strong>Recovery is a journey,</strong> and relapses don't mean failure.</li>
                <li><strong>Support is available 24/7.</strong> Don't hesitate to reach out when you need help.</li>
              </ul>
            </div>
          </div>

          <div className="disclaimer-section">
            <h2>⚠️ Disclaimer</h2>
            <p>
              This page provides general information and resources about alcohol dependency. 
              It is not intended as a substitute for professional medical advice, diagnosis, or treatment. 
              Always seek the advice of qualified health providers with any questions you may have regarding a medical condition.
              If you are experiencing a medical emergency, call 911 immediately.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}

export default DrinkResponsibly;